import { Link } from 'react-router-dom';

export default function CtaBand() {
  return (
    <section className="overflow-hidden rounded-lg bg-primary-600 px-6 py-10 md:px-10 md:py-14">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
        <div className="max-w-2xl">
          <p className="mb-2 font-label text-xs uppercase tracking-[0.28em] text-primary-100">
            Tip Line
          </p>
          <h2 className="font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl">
            你手里也有一条没人核对的线索吗
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-primary-100">
            无论是招标文件、董事会纪要，还是被删掉的那份报告，都可以投递给我们。可以不署名，只需留一个可联络的邮箱以便核对细节。
          </p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row lg:shrink-0">
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 font-label text-sm font-medium text-primary-700 transition-colors hover:bg-background-100"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-send-plane-line" />
            </span>
            投递线索
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-primary-300 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
          >
            了解核对流程
          </Link>
        </div>
      </div>
    </section>
  );
}